"use strict";

exports.__esModule = true;
exports.default = void 0;
/**
 * Get Yoga computed position. Zero otherwise
 *
 * @param {Object} node
 * @return {Object} position
 */
var getAbsolutePosition = function getAbsolutePosition(node) {
  var yogaNode = node._yogaNode;
  var position = {
    absTop: 0,
    absRight: 0,
    absBottom: 0,
    absLeft: 0
  };
  while (yogaNode) {
    var _yogaNode, _yogaNode2, _yogaNode3, _yogaNode4;
    position.absTop += ((_yogaNode = yogaNode) === null || _yogaNode === void 0 ? void 0 : _yogaNode.getComputedTop()) || 0;
    position.absRight += ((_yogaNode2 = yogaNode) === null || _yogaNode2 === void 0 ? void 0 : _yogaNode2.getComputedRight()) || 0;
    position.absBottom += ((_yogaNode3 = yogaNode) === null || _yogaNode3 === void 0 ? void 0 : _yogaNode3.getComputedBottom()) || 0;
    position.absLeft += ((_yogaNode4 = yogaNode) === null || _yogaNode4 === void 0 ? void 0 : _yogaNode4.getComputedLeft()) || 0;
    yogaNode = yogaNode.getParent();
  }
  return position;
};
var _default = exports.default = getAbsolutePosition;